import React, { useState } from 'react';
import { Checkbox } from '../../../components/ui/Checkbox';
import Button from '../../../components/ui/Button';

const NotificationSettings = ({ initialSettings }) => {
  const [settings, setSettings] = useState(initialSettings);
  const [hasChanges, setHasChanges] = useState(false);

  const handleToggle = (key) => {
    setSettings(prev => ({
      ...prev,
      [key]: !prev?.[key]
    }));
    setHasChanges(true);
  };

  const handleSave = () => {
    console.log('Saving notification settings:', settings);
    setHasChanges(false);
  };

  const handleReset = () => {
    setSettings(initialSettings);
    setHasChanges(false);
  };

  return (
    <div className="card">
      <h3 className="text-lg md:text-xl font-semibold text-foreground mb-6">
        Varslingsinnstillinger
      </h3>
      <div className="space-y-6">
        <div>
          <h4 className="text-base md:text-lg font-medium text-foreground mb-4">
            E-postvarsler
          </h4>
          <div className="space-y-4">
            <Checkbox
              label="Fakturapåminnelser"
              description="Motta påminnelser om kommende betalinger"
              checked={settings?.emailInvoiceReminders}
              onChange={() => handleToggle('emailInvoiceReminders')}
            />
            <Checkbox
              label="Abonnementsoppdateringer"
              description="Varsler om endringer i abonnementet ditt"
              checked={settings?.emailSubscriptionUpdates}
              onChange={() => handleToggle('emailSubscriptionUpdates')}
            />
            <Checkbox
              label="Markedsføring og tilbud"
              description="Motta informasjon om nye funksjoner og tilbud"
              checked={settings?.emailMarketing}
              onChange={() => handleToggle('emailMarketing')}
            />
          </div>
        </div>

        <div className="pt-6 border-t-2 border-border">
          <h4 className="text-base md:text-lg font-medium text-foreground mb-4">
            SMS-varsler
          </h4>
          <div className="space-y-4">
            <Checkbox
              label="Betalingsbekreftelser"
              description="Få SMS når betalinger er gjennomført"
              checked={settings?.smsPaymentConfirmations}
              onChange={() => handleToggle('smsPaymentConfirmations')}
            />
            <Checkbox
              label="Kontoutløpsvarsler"
              description="Varsler når abonnementet nærmer seg utløp"
              checked={settings?.smsExpiryAlerts}
              onChange={() => handleToggle('smsExpiryAlerts')}
            />
          </div>
        </div>

        <div className="pt-6 border-t-2 border-border">
          <h4 className="text-base md:text-lg font-medium text-foreground mb-4">
            Push-varsler
          </h4>
          <div className="space-y-4">
            <Checkbox
              label="Trafikkvarsler"
              description="Sanntidsvarsler om trafikkforhold"
              checked={settings?.pushTrafficAlerts}
              onChange={() => handleToggle('pushTrafficAlerts')}
            />
            <Checkbox
              label="Bompasseringer"
              description="Varsler når du passerer bomstasjoner"
              checked={settings?.pushTollPassages}
              onChange={() => handleToggle('pushTollPassages')}
            />
          </div>
        </div>
      </div>
      {hasChanges && (
        <div className="flex flex-col sm:flex-row gap-3 mt-8 pt-6 border-t-2 border-border">
          <Button
            variant="default"
            size="default"
            onClick={handleSave}
            className="flex-1"
            style={{ 
              background: 'var(--color-accent)', 
              borderColor: 'var(--color-accent)' 
            }}
          >
            Lagre endringer
          </Button>
          <Button
            variant="outline"
            size="default"
            onClick={handleReset}
            className="flex-1"
          >
            Tilbakestill
          </Button>
        </div>
      )}
    </div>
  );
};

export default NotificationSettings;